import { init, ErrorBoundary } from "@sentry/react";
import { getConfigSync } from "storefront/GrailedAPI/v1/Config/getConfig";

const sentryInit = () => {
  const config = getConfigSync();

  init({
    debug: false,
    dsn: config.sentry.clientDsn,
    environment: config.env || "development",
    maxBreadcrumbs: 10,
  });
};

export { ErrorBoundary, sentryInit };
